<submit-petition-library  (onDialogClose)="handleDialogClose()"
 [primaryData]="primaryData" style="width:100%" [simplifyH1b]="true"></submit-petition-library>
